import * as go from 'gojs';
import noop from 'lodash/noop';
import { registerNodeTemplate } from '../../common/utils/registerNodeTemplate';
import { freeDrawNodeTemplate } from '../free-draw-node';

export const setupFreeDrawNode = (diagram: go.Diagram, categoryName: string) => {
  registerNodeTemplate(diagram, categoryName, freeDrawNodeTemplate());
  return noop;
};
